module.exports = __webpack_public_path__ + "img/asddsystem.44d845cc.jpg";